(function () {
  function track(name, params) {
    if (window.salutTrack) window.salutTrack(name, params);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var itemData = document.getElementById('salut-ga4-item');
    if (!itemData) return;
    try { track('view_item', JSON.parse(itemData.textContent)); } catch (e) {}
  });

  function toItem(line) {
    return {
      item_id: line.sku || String(line.product_id),
      item_name: line.product_title || line.title,
      item_variant: line.variant_title || '',
      price: (line.final_price || line.price || 0) / 100,
      quantity: line.quantity || 1,
      item_brand: line.vendor || ''
    };
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function onCartUpdate(event) {
    if (!event || (event.source !== 'product-form' && event.source !== 'salut-bundle')) return;
    var data = event.cartData || {};
    var lines = Array.isArray(data.items) ? data.items : (data.variant_id ? [data] : []);
    if (!lines.length) return;
    var items = lines.map(toItem);
    var value = items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
    track('add_to_cart', { currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MDL', value: Math.round(value * 100) / 100, items: items });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  subscribe(PUB_SUB_EVENTS.cartAdd, onCartUpdate);
})();
